import { render, staticRenderFns } from "./GoogleTrendTable.vue?vue&type=template&id=27ea3e5c&scoped=true&lang=pug"
import script from "./GoogleTrendTable.vue?vue&type=script&lang=js"
export * from "./GoogleTrendTable.vue?vue&type=script&lang=js"
import style0 from "./GoogleTrendTable.vue?vue&type=style&index=0&id=27ea3e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ea3e5c",
  null
  
)

export default component.exports